<div class="feedback-container">
  @if (evaluationData) {
  <h2 class="feedback-title">Performance Evaluation</h2>

  <div class="feedback-content">
    <div class="general-score">
      <h3>Overall Score</h3>
      <p class="score">{{ evaluationData.overall_score.rating }} / 100 (Level: {{ evaluationData.overall_score.level }})</p>
    </div>

    <div class="feedback-details">
      <h3>Detailed Assessments</h3>
      @for (assessment of evaluationData.assessments | keyvalue; track assessment.key) {
      <div>
        <h4>{{ assessment.key.replace('_', ' ') | titlecase }}</h4>
        <p>
          <span class="score">Score: {{ assessment.value.score }} / 100</span> |
          <span class="level">Level: {{ assessment.value.level }}</span>
        </p>
        <p class="comment"><strong>Feedback:</strong> {{ assessment.value.feedback }}</p>
        @if (assessment.value.suggestions?.length > 0) {
        <div>
          <strong>Suggestions:</strong>
          <ul>
            @for (suggestion of assessment.value.suggestions; track $index) {
            <li>{{ suggestion }}</li>
            }
          </ul>
        </div>
        }
      </div>
      }
    </div>

    <div class="conversation-analysis">
      <h3>Conversation Analysis</h3>
      <p><strong>Dominant Register:</strong> {{ evaluationData.conversation_analysis.dominant_register }}</p>
      <p><strong>Conversation Type:</strong> {{ evaluationData.conversation_analysis.conversation_type }}</p>
      @if (evaluationData.conversation_analysis.key_observations?.length > 0) {
      <div>
        <strong>Key Observations:</strong>
        <ul>
          @for (observation of evaluationData.conversation_analysis.key_observations; track $index) {
          <li>{{ observation }}</li>
          }
        </ul>
      </div>
      } @if (evaluationData.conversation_analysis.notable_patterns?.length > 0) {
      <div>
        <strong>Notable Patterns:</strong>
        <ul>
          @for (pattern of evaluationData.conversation_analysis.notable_patterns; track $index) {
          <li>{{ pattern }}</li>
          }
        </ul>
      </div>
      }
    </div>

    <div class="actionable-feedback">
      <h3>Actionable Feedback</h3>
      @if (evaluationData.actionable_feedback.immediate_focus_areas?.length > 0) {
      <div>
        <strong>Immediate Focus Areas:</strong>
        <ul>
          @for (area of evaluationData.actionable_feedback.immediate_focus_areas; track $index) {
          <li>{{ area }}</li>
          }
        </ul>
      </div>
      } @if (evaluationData.actionable_feedback.practice_recommendations?.length > 0) {
      <div>
        <strong>Practice Recommendations:</strong>
        <ul>
          @for (recommendation of evaluationData.actionable_feedback.practice_recommendations; track $index) {
          <li>{{ recommendation }}</li>
          }
        </ul>
      </div>
      } @if (evaluationData.actionable_feedback.next_steps?.length > 0) {
      <div>
        <strong>Next Steps:</strong>
        <ul>
          @for (step of evaluationData.actionable_feedback.next_steps; track $index) {
          <li>{{ step }}</li>
          }
        </ul>
      </div>
      }
    </div>
  </div>

  <div class.bind="'feedback-footer'">
    <p-button label="Close" (onClick)="closeDialog()"></p-button>
  </div>

  } @else {
  <div class="loading-container">
    <p>Loading feedback...</p>
  </div>
  }
</div>
